import React, { useState, useEffect, useRef } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputText } from "primereact/inputtext";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { Button } from "primereact/button";

import Snackbar from "@mui/material/Snackbar";
import IconButton from "@mui/material/IconButton";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import CloseIcon from "@mui/icons-material/Close";

import MenuItem from "@mui/material/MenuItem";
import axios from "axios";
import { Dialog } from "primereact/dialog";
import Select from "@mui/material/Select";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { TextField, TextareaAutosize } from "@mui/material";

import { Toast } from 'primereact/toast';
        
import FicheLogTerminal from "./journal";
import { fr } from "date-fns/locale";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import formatToISODate from "../formatDateISO";
import {Calendar} from "primereact/calendar";

import EditIcon from "@mui/icons-material/Edit";
import CheckIcon from "@mui/icons-material/Check";

import convertTimeStringToDate from "../timeToDate";


import {
  formatDateWithDaysAgo,
  clientTemplate,
  contactTemplate,
  invitesTemplate,
  typeTemplate,
  nameTemplate,
  phoneTemplate,
  emailTemplate,
  amountTemplate,
  formatDateWithDaysAgoAndNbCall
} from '../formatTableau';

import DevisDemenagementDialog from "./DevisDialogDem";


const apiUrl = process.env.REACT_APP_API_URL;
export default function Suivis({ searchTerm = "" }) {
  const [editMode, setEditMode] = useState(false);
  const [loading, setLoading] = useState(true);



  const toast = useRef(null);
  const [suivis, setSuivis] = useState([]);

  const [copiedText, setCopiedText] = useState("");
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [openSnackbarMail, setOpenSnackbarMail] = useState(false);
const [snackbarMessage, setSnackbarMessage] = useState("");

  const [visible, setVisible] = useState(false);

  const [rechercheSuivis, setRechercheSuivis] = useState("");
  const [tempDateDevis, setTempDateDevis] = useState("");
  const [tempIdFicheDem, setTempIdFicheDem] = useState("");
  const [tempNom, setTempNom] = useState("");
  const [tempEmail, setTempEmail] = useState("");
  const [tempTel, setTempTel] = useState("");
  const [tempAdresse, setTempAdresse] = useState("");
  const [tempRegion, setTempRegion] = useState("");
  const [tempStatus, setTempStatus] = useState("");

  const [filtreSuivis, setFiltreSuivis] = useState("");
  const [visibleRequired, setVisibleRequired] = useState(true);
  const [note, setNote] = useState("");

  const [appel, setAppel] = useState("");
  const [date, setDate] = useState(null);

  const [validation, setValidation] = useState("");
  const [dateValidation, setDateValidation] = useState("");
  const [nbAppels, setNbAppels] = useState("");

  const [heureDem,setHeureDem]= useState("");

  const [devisDialogVisible, setDevisDialogVisible] = useState(false);
  const [selectedFicheForDevis, setSelectedFicheForDevis] = useState(null);
  const [forceNewDevis, setForceNewDevis] = useState(false);

  const getLabel = () => {
    switch (appel) {
      case "0":
        return "Date de la visite";
      case "1":
        return "Date de visite requise";

      case "2":
        return "Date de rappel";

      case "3":
        return "Date validation requise";
      case "4":
        return "Date déménagement requise";
      default:
        return "Date";
    }
  };

  const copyToClipboard = (text) => {
    if (text !== "") {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard
          .writeText(text)
          .then(() => {
            setCopiedText(text);
            setOpenSnackbar(true);
          })
          .catch((error) => {
            console.error(
              "Erreur lors de la copie dans le presse-papiers : ",
              error
            );
          });
      } else {
        // Utiliser l'API de sélection de texte comme solution de secours
        const textArea = document.createElement("textarea");
        textArea.value = text;
        document.body.appendChild(textArea);
        textArea.select();
        document.execCommand("copy");
        document.body.removeChild(textArea);

        setCopiedText(text);
        setOpenSnackbar(true);
      }
    }
  };
  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };
const handleCloseSnackbarMail = () => {
  setOpenSnackbarMail(false);
};
  useEffect(() => {
    axios
      .get(`${apiUrl}/IHM/api/ficheDem.php?ficheSuivis`)
      .then((response) => {
        setSuivis(response.data);
      })
      .catch((error) => {
        console.error("Erreur lors du chargement des factures :", error);
      })
      .finally(() => {
            setLoading(false);
      });
  }, []);

  useEffect(() => {
    const recherche = searchTerm.toLowerCase();
    const filteredList = suivis.filter((fiche) => {
      const nom = fiche.nom?.toLowerCase() || "";
      const tel = fiche.tel?.toLowerCase() || "";
      const adresse = fiche.adresse?.toLowerCase() || "";
      const email = fiche.email?.toLowerCase() || "";

      return (
        nom.includes(recherche) ||
        tel.includes(recherche) ||
        adresse.includes(recherche)||
        email.includes(recherche)

      );
    });
    setFiltreSuivis(filteredList);
  }, [searchTerm, suivis]);

  useEffect(() => {
    if (dateValidation) {
      setVisibleRequired(false);
    }
  }, [dateValidation]);

  const enteteTableauNouvelle = () => {
    return (
      <div className="flex justify-content-end">
        {/* <IconField iconPosition="left">
          <InputIcon className="pi pi-search" />
          <InputText
            value={rechercheSuivis}
            onChange={(e) => setRechercheSuivis(e.target.value)}
            placeholder="Rechercher"
          />
        </IconField>
        <Button
          icon="pi pi-plus"
          size="small"
          severity="success"
          aria-label="Ajouter"
          onClick={() => window.open("https://tally.so/r/mDVg6q", "_blank")}
          style={{
            width: 20,
            height: 20,
            padding: 0,
            fontSize: "14px",
          }}
        /> */}
      </div>
    );
  };

  const setInfoClick = (idFicheDem, nom, tel, email, adresse, region) => {
    setAppel("");
    setValidation("");
    setNote("");
    setDate("");

    setTempNom(nom);
    setTempTel(tel);
    setTempEmail(email);
    setTempAdresse(adresse);
    setTempRegion(region);
    setTempIdFicheDem(idFicheDem);

    setHeureDem(null);

    axios
      .get(`${apiUrl}IHM/api/ficheDem.php?idFicheDem=${idFicheDem}`)
      .then((response) => {
        //setNote(response.data[0].note);
        setAppel(response.data[0].etat);
        setTempStatus(response.data[0].status);
        setTempDateDevis(response.data[0].dateDevis);
        setNbAppels(response.data[0].nbappels);

        setVisible(true);
      })
      .catch((error) => {
        console.error(
          "Une erreur s'est produite lors de la récupération de la fiche :",
          error
        );
      });
  };

  const handleSavePhoneCall = async () => {
    if (!date && appel === "1") {
      alert("La date de visites est obligatoire");
      return;
    } else if (!date && appel === "3") {
      alert("La date de validation du devis est obligatoire");
      return;
    }

    let data = {
      idFicheDem: tempIdFicheDem,
      etat: appel,
      note: note,
      adminMod: localStorage.getItem("us"),
    };

    const isoDate = formatToISODate(date);
    const isoDateRappel = dateValidation
      ? formatToISODate(dateValidation)
      : null;

    if (appel === "2") {
      // ici on enregistre uniquement dateRappel
      data.dateRappel = isoDate;
    } else if (appel === "3") {
      // ici on enregistre dateValidation, et potentiellement dateRappel aussi
      data.dateValidation = isoDate;
      if (isoDateRappel) {
        data.dateRappel = isoDateRappel;
      }
    } else if (appel === "4") {
      const pad = (n) => String(n).padStart(2, "0");
      const heureDemSQL = heureDem
        ? `${pad(heureDem.getHours())}:${pad(heureDem.getMinutes())}:00`
        : null;
      data.dateDemenagement = isoDate;
      data.heureDem = heureDemSQL;
    } else {
      data.date = isoDate;
    }

    try {
      let response;
      if (appel === "6") {
        response = await axios.post(`${apiUrl}IHM/api/zotDevis.php`, {
          idFicheDem: tempIdFicheDem,
          note: note,
          adminMod: localStorage.getItem("us"),
          date: formatToISODate(date),
        });
        if (response.data.success) {
          //alert(response.data.message);
          window.location.reload();
        } else {
          //alert("Erreur : " + response.data.message);
        }
      } else {
        response = await axios.put(`${apiUrl}IHM/api/ficheDem.php`, data);
      }

      if (response.data) {
        setVisible(false);
        window.location.reload();
      } else {
        setVisible(false);
        window.location.reload();
      }
    } catch (error) {
      console.error(
        "Erreur lors de la sauvegarde de l'appel téléphonique",
        error
      );
    }
  };

   const handleValidate = async () => {
      try {
        await axios.post(`${apiUrl}IHM/api/update_ficheDem.php`, {
          idFicheDem: tempIdFicheDem,
          nom: tempNom,
          telephone: tempTel,
          email: tempEmail,
          adresse: tempAdresse,
          region: tempRegion,
        });
        setEditMode(false);
      } catch (error) {
        console.error("Erreur de mise à jour :", error);
        alert("Erreur lors de la sauvegarde");
      } finally {
      }
    };
  
    const header = (
      <div className="flex justify-between items-center w-full">
        <span className="font-semibold text-lg mr-2">Fiche de déménagement</span>
        <div className="flex items-center gap-2">
          <span style={{ cursor: "pointer" }}>
            {editMode ? (
              <>
                <span
                  onClick={() => handleValidate()}
                  style={{
                    border: "1px solid #22c55e",
                    borderRadius: "50%",
                    color: "#fff",
                    width: "28px",
                    height: "28px",
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "pointer",
                    marginRight: "8px",
                    transition: "all 0.2s ease",
  
                    backgroundColor: "#22c55e",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = "#22c55e";
                    e.currentTarget.style.color = "#fff";
                  }}
                >
                  <CheckIcon sx={{ fontSize: 16 }} />
                </span>
  
                <span
                  onClick={() => setEditMode(false)}
                  style={{
                    border: "1px solid #ef4444",
                    borderRadius: "50%",
                    color: "#ffffffff",
                    width: "28px",
                    height: "28px",
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "pointer",
                    transition: "all 0.2s ease",
                    backgroundColor: "#ef4444",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = "#ef4444";
                    e.currentTarget.style.color = "#fff";
                  }}
                >
                  <CloseIcon sx={{ fontSize: 16 }} />
                </span>
              </>
            ) : (
              <span
                style={{
                  border: "1px solid #4b5563",
                  borderRadius: "50%",
                  color: "#ffffffff",
                  width: "28px",
                  height: "28px",
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                  marginRight: "8px",
                  transition: "all 0.2s ease",
                  backgroundColor: "#4b5563",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = "#4b5563";
                  e.currentTarget.style.color = "#fff";
                }}
                onClick={() => setEditMode(true)}
              >
                {" "}
                <EditIcon sx={{ fontSize: 16 }} />{" "}
              </span>
            )}
          </span>
        </div>
      </div>
    );

    const openDevisDialog = (rowData, isNew = false) => {
      setForceNewDevis(isNew);
      setSelectedFicheForDevis({
        idFicheDem: rowData.idFicheDem,
        nom: rowData.nom,
        email: rowData.email,
        tel: rowData.tel,
        region: rowData.region,
        adresse: rowData.adresse,
        note: rowData.note,
      });
      setDevisDialogVisible(true);
    };

  return (
    <>
      <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        open={openSnackbarMail}
        autoHideDuration={1000}
        onClose={handleCloseSnackbarMail}
        message={snackbarMessage}
        action={
          <React.Fragment>
            <IconButton
              size="small"
              aria-label="close"
              color="inherit"
              onClick={handleCloseSnackbarMail}
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          </React.Fragment>
        }
      />
      <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        open={openSnackbar}
        autoHideDuration={1000}
        onClose={handleCloseSnackbar}
        message={`Copie réussie de " ${
          copiedText === "location.mail" ? "e-mail" : copiedText
        } "`}
        action={
          <React.Fragment>
            <IconButton
              size="small"
              aria-label="close"
              color="inherit"
              onClick={handleCloseSnackbar}
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          </React.Fragment>
        }
      />

      <DevisDemenagementDialog
        visible={devisDialogVisible}
        onHide={() => {
          setDevisDialogVisible(false);
          setSelectedFicheForDevis(null);
        }}
        ficheData={selectedFicheForDevis}
        onDevisGenerated={() => {
          axios
            .get(`${apiUrl}/IHM/api/ficheDem.php?ficheSuivis`)
            .then((response) => setSuivis(response.data));
        }}
        forceNew={forceNewDevis}
      />

      <Dialog
        blockScroll
        visible={visible}
        header={header}
        className="custom-dialog"
        style={{ width: "40vw" }}
        modal
        onHide={() => {
          setVisible(false);
          setEditMode(false);
        }}
        breakpoints={{ "960px": "100vw", "640px": "100vw" }}
      >
        <div className="p-3">
          <div className="grid">
            {/* Etat actuel */}
            <div className="col-12 md:col-6">
              <div className="p-2 px-0 surface-100 border-round-sm flex justify-between align-items-left">
                <span className="font-bold">État actuel :</span>
                <span
                  className="p-1 px-2 text-sm"
                  style={{ background: "#e5e7eb", borderRadius: "5px" }}
                >
                  {tempStatus}{" "}
                  <small>
                    <small>({nbAppels})</small>
                  </small>
                </span>
              </div>
            </div>

            {/* Etat souhaité */}
            <div className="col-12 md:col-6">
              <div className="p-2 px-0 surface-100 border-round-sm flex justify-between align-items-left">
                <span className="font-bold">État souhaité :</span>
                <Select
                  labelId="etat-label"
                  id="etat-select"
                  value={appel}
                  onChange={(e) => setAppel(e.target.value)}
                  displayEmpty
                  style={{
                    minWidth: "130px",
                    maxWidth: "130px",
                    maxHeight: "20px",
                  }}
                >
                  <MenuItem value="" disabled>
                    Séléctionner un état
                  </MenuItem>
                  <MenuItem value="0">Visites</MenuItem>
                  <MenuItem value="1">Devis</MenuItem>
                  <MenuItem value="2">Suivis</MenuItem>
                  <MenuItem value="3">Agenda</MenuItem>
                  <MenuItem value="4">Déménagement</MenuItem>
                  <MenuItem value="5">Abandonnée</MenuItem>
                  <MenuItem value="6">Vers Zotdevis</MenuItem>
                </Select>
              </div>
            </div>
          </div>
          <div className="grid">
            <div className="col-12 md:col-6">
              <div
                className="p-2 px-0 border-round-sm flex justify-between align-items-left"
                style={{ background: "#f9fafb", borderRadius: "5px" }}
              >
                <span className="font-bold">Nom :</span>

                {editMode ? (
                  <InputText
                    value={tempNom}
                    onChange={(e) => setTempNom(e.target.value)}
                    style={{ height: "10px" }}
                  />
                ) : (
                  <span
                    onClick={() => copyToClipboard(tempNom)}
                    className="cursor-pointer"
                  >
                    {tempNom} <ContentCopyIcon sx={{ fontSize: 12 }} />
                  </span>
                )}
              </div>
            </div>

            <div className="col-12 md:col-6">
              <div
                className="p-2 px-0 border-round-sm flex justify-between align-items-left"
                style={{ background: "#f9fafb", borderRadius: "5px" }}
              >
                <span className="font-bold">Email :</span>

                {editMode ? (
                  <InputText
                    value={tempEmail}
                    onChange={(e) => setTempEmail(e.target.value)}
                    style={{ height: "10px" }}
                  />
                ) : (
                  <span
                    onClick={() => copyToClipboard(tempEmail)}
                    className="cursor-pointer"
                  >
                    {tempEmail} <ContentCopyIcon sx={{ fontSize: 12 }} />
                  </span>
                )}
              </div>
            </div>
          </div>

          {/* Ligne 2 */}
          <div className="grid">
            <div className="col-12 md:col-6">
              <div
                className="p-2 px-0 border-round-sm flex justify-between align-items-left"
                style={{ background: "#f9fafb", borderRadius: "5px" }}
              >
                <span className="font-bold">Téléphone :</span>

                {editMode ? (
                  <InputText
                    value={tempTel}
                    onChange={(e) => setTempTel(e.target.value)}
                    style={{ height: "10px" }}
                  />
                ) : (
                  <span
                    onClick={() => copyToClipboard(tempTel)}
                    className="cursor-pointer"
                  >
                    {tempTel} <ContentCopyIcon sx={{ fontSize: 12 }} />
                  </span>
                )}
              </div>
            </div>

            <div className="col-12 md:col-6">
              <div
                className="p-2 px-0 border-round-sm flex justify-between align-items-left"
                style={{ background: "#f9fafb", borderRadius: "5px" }}
              >
                <span className="font-bold">Région :</span>

                {editMode ? (
                  <InputText
                    value={tempRegion}
                    onChange={(e) => setTempRegion(e.target.value)}
                    style={{ height: "10px" }}
                  />
                ) : (
                  <span
                    onClick={() => copyToClipboard(tempRegion)}
                    className="cursor-pointer"
                  >
                    {tempRegion} <ContentCopyIcon sx={{ fontSize: 12 }} />
                  </span>
                )}
              </div>
            </div>
          </div>

          {/* Ligne 3 */}
          <div className="grid">
            <div className="col-12">
              <div
                className="p-2 px-0 border-round-sm flex justify-between align-items-left"
                style={{ background: "#f9fafb", borderRadius: "5px" }}
              >
                <span className="font-bold">Adresse :</span>
                {editMode ? (
                  <InputText
                    value={tempAdresse}
                    onChange={(e) => setTempAdresse(e.target.value)}
                    style={{ height: "10px" }}
                  />
                ) : (
                  <span
                    onClick={() => copyToClipboard(tempAdresse)}
                    className="cursor-pointer"
                  >
                    {tempAdresse} <ContentCopyIcon sx={{ fontSize: 12 }} />
                  </span>
                )}
              </div>
            </div>
          </div>

          {/* Ligne Date optionnel*/}
          {(appel === "1" ||
            appel === "2" ||
            appel === "3" ||
            appel === "4") && (
            <div className="grid">
              <div className="col-12 md:col-12">
                <div className="p-2 px-0 border-round-sm surface-100 flex flex-column gap-2 px-0">
                  <span className="font-bold">{getLabel()}</span>
                  <LocalizationProvider
                    dateAdapter={AdapterDateFns}
                    adapterLocale={fr}
                  >
                    <DatePicker
                      value={date}
                      onChange={(newValue) => setDate(newValue)}
                      renderInput={(props) => (
                        <TextField {...props} fullWidth />
                      )}
                      inputFormat="dd/MM/yyyy"
                      minDate={new Date()}
                    />
                  </LocalizationProvider>
                </div>
              </div>
            </div>
          )}

          {appel === "3" && (
            <div className="grid">
              <div className="col-12 md:col-12">
                <div className="p-2 px-0 border-round-sm surface-100 flex flex-column gap-2 px-0">
                  <span className="font-bold">Date de rappel </span>
                  <LocalizationProvider
                    dateAdapter={AdapterDateFns}
                    adapterLocale={fr}
                  >
                    <DatePicker
                      value={dateValidation}
                      onChange={(newValue) => setDateValidation(newValue)}
                      renderInput={(props) => (
                        <TextField {...props} required="false" fullWidth />
                      )}
                      inputFormat="dd/MM/yyyy"
                      minDate={new Date()}
                    />
                  </LocalizationProvider>
                </div>
              </div>
            </div>
          )}

          {appel === "4" && (
            <>
              <div className="py-0 px-0 border-round-sm surface-100 flex flex-column">
                <span className="font-bold">Heure du déménagement:</span>
              </div>
              <div className="grid">
                <div className="col-12 md:col-12">
                  <Calendar
                    id="calendar-timeonly"
                    value={heureDem}
                    onChange={(e) => setHeureDem(e.value)}
                    timeOnly
                    showSeconds={false}
                    inputMode="none"
                    style={{
                      width: "100%",
                      borderRadius: "5px",
                      border: "1px solid #000",
                    }}
                    className="mt-2"
                  />
                </div>
              </div>
            </>
          )}

          <div className="grid">
            <div className="col-12 md:col-12">
              <div className="py-0 px-0 border-round-sm surface-100 flex flex-column">
                <span className="font-bold">Ajouter une note :</span>
              </div>
            </div>
          </div>
          <div className="grid">
            <div className="col-12 md:col-12">
              <TextareaAutosize
                variant="standard"
                minRows={5}
                maxRows={10}
                value={note}
                onChange={(e) => setNote(e.target.value)}
                style={{ width: "100%", borderRadius: "5px" }}
                className="mt-2"
              />
            </div>
          </div>

          <div className="grid">
            <div className="col-12 md:col-12">
              <div className="border-round-sm surface-100 flex flex-column"></div>
              <Button
                label="Enregistrer l'état et la note"
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = "#094ed8";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = "#2563eb";
                }}
                className="w-full text-white"
                style={{
                  background: "#094ed8",
                  border: "1px solid #094ed8",
                  padding: "0.75rem",
                  borderRadius: "5px",
                }}
                onClick={() => {
                  if (appel) {
                    handleSavePhoneCall();
                  }
                }}
              />
            </div>
          </div>

          <FicheLogTerminal idFicheDem={tempIdFicheDem} />
        </div>
      </Dialog>

      <DataTable
        value={filtreSuivis}
        paginator
        size="small"
        rows={25}
        header={enteteTableauNouvelle}
        rowsPerPageOptions={[5, 10, 25, 50]}
        tableStyle={{ minWidth: "50rem" }}
        scrollable
        scrollDirection="horizontal"
        paginatorTemplate={
          "FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink RowsPerPageDropdown"
        }
        paginatorRight={
          <span style={{ margin: "10px", fontWeight: "bold" }}>
            Résultats : {filtreSuivis.length}
          </span>
        }
        loading={loading}
        loadingIcon="pi pi-spin pi-spinner"
        emptyMessage={
          loading
            ? "Chargement des fiches de suivis..."
            : "Aucune fiche pour le moment"
        }
      >
        <Column
          field="dateDevis"
          header="Date d’envoi devis"
          body={(rowData) =>
            formatDateWithDaysAgoAndNbCall(rowData.dateDevis, rowData)
          }
        />

        <Column
          field="dateRappel"
          header="Date de rappel"
          body={(rowData) => formatDateWithDaysAgo(rowData.dateRappel)}
        />

        <Column
          field="nom"
          header="Client"
          body={(rowData) => nameTemplate(rowData, copyToClipboard)}
        />

        <Column
          field="email"
          header="Contact"
          body={(rowData) => contactTemplate(rowData, copyToClipboard)}
        />

        <Column
          field="note"
          header="Note"
          bodyStyle={{ fontSize: "14px", width: "250px" }}
          body={(rowData) => {
            const date = new Date(rowData.dateUpdate);
            const day = String(date.getDate()).padStart(2, "0");
            const month = String(date.getMonth() + 1).padStart(2, "0");
            const year = date.getFullYear();

            return (
              <div>
                <span
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "4px",
                  }}
                >
                  {rowData.note}
                  <small style={{ fontSize: "10px" }}>
                    ({day}/{month})
                  </small>
                </span>
              </div>
            );
          }}
        />

        <Column
          header="Actions"
          style={{ textAlign: "center", width: "120px" }}
          body={(rowData) => (
            <div
              style={{ display: "flex", justifyContent: "center", gap: "5px" }}
            >
              {rowData.a_devis == 1 && (
                <>
                  <Button
                    icon="pi pi-file-pdf"
                    severity="info"
                    text
                    raised
                    size="small"
                    tooltip="Gérer le devis"
                    tooltipOptions={{
                      position: "top",
                      style: { fontSize: "0.7rem" },
                    }}
                    onClick={() => openDevisDialog(rowData, false)}
                  />

                  <Button
                    icon="pi pi-plus"
                    severity="warning"
                    text
                    raised
                    size="small"
                    tooltip="Nouveau devis"
                    tooltipOptions={{
                      position: "top",
                      style: { fontSize: "0.7rem" },
                    }}
                    onClick={() => openDevisDialog(rowData, true)}
                  />
                </>
              )}

              {rowData.a_devis != 1 && (
                <Button
                  icon="pi pi-file-plus"
                  severity="danger"
                  size="small"
                  text
                  raised
                  tooltip="Créer un devis"
                  tooltipOptions={{
                    position: "top",
                    style: { fontSize: "0.7rem" },
                  }}
                  onClick={() => openDevisDialog(rowData, false)}
                />
              )}

              <Button
                icon="pi pi-phone"
                severity="success"
                size="small"
                text
                raised
                onClick={() => {
                  setInfoClick(
                    rowData.idFicheDem,
                    rowData.nom,
                    rowData.tel,
                    rowData.email,
                    rowData.adresse,
                    rowData.region,
                  );
                }}
              />

              <Button
                icon="pi pi-envelope"
                severity="info"
                size="small"
                text
                raised
                label={`${rowData.nombre_mailSuivi}`}
                style={{ flexShrink: 0, marginLeft: "3px" }}
                onClick={() => {
                  axios
                    .post(`${apiUrl}/IHM/api/sendMailSuivis.php`, {
                      id: rowData.idFicheDem,
                      nom: rowData.nom,
                      email: rowData.email,
                      datedem: rowData.dateDevis,
                      adminMod: localStorage.getItem("us"),
                    })
                    .then((res) => {
                      if (res.data.success) {
                        setSnackbarMessage(
                          "Le mail a bien été envoyé pour " + rowData.nom + ".",
                        );
                        setOpenSnackbarMail(true);
                        window.location.reload();
                      } else {
                        setSnackbarMessage(
                          res.data.message || "Envoi impossible",
                        );
                        setOpenSnackbarMail(true);
                      }
                    })
                    .catch((err) => {
                      console.error("Erreur envoi mail:", err);
                      setSnackbarMessage("Impossible d’envoyer le mail");
                      setOpenSnackbarMail(true);
                    });
                }}
              />
            </div>
          )}
        />
      </DataTable>
    </>
  );
}
